import { useQuery } from '@tanstack/react-query';
import React from 'react';
import type { AssignmentShift } from '../../../../../js/api';
import { AssignmentsService } from '../../../../../js/api';
import { ActivityLog } from '../../../components/activity-log';
import { Dialog, DialogBody, DialogCloseButton, DialogTitle } from '../../../components/dialog';
import type { ActivityHistory, ActivityStatusHistory } from '../../../utils/activity-types';
import { formatDateTimeRange } from '../../../utils/date';
import {
  ASSIGNMENT_SHIFT_CHANGE_HISTORY_QUERY_KEY,
  ASSIGNMENT_SHIFT_STATUS_HISTORY_QUERY_KEY,
} from './queryKeys';

export const ShiftHistoryModal: React.FC<{
  open: boolean;
  onClose: () => void;
  shift?: AssignmentShift;
}> = ({ open, onClose, shift }) => {
  const shiftId = shift?.id;

  const { data: statusHistory } = useQuery({
    queryKey: [ASSIGNMENT_SHIFT_STATUS_HISTORY_QUERY_KEY, shiftId],
    queryFn: () =>
      AssignmentsService.assignmentsAssignmentShiftStatusHistoryRetrieve({
        id: shiftId!,
        sort: 'desc',
      }),
    enabled: open && !!shiftId,
  });

  const { data: changeHistory } = useQuery({
    queryKey: [ASSIGNMENT_SHIFT_CHANGE_HISTORY_QUERY_KEY, shiftId],
    queryFn: () =>
      AssignmentsService.assignmentsAssignmentShiftChangeHistoryRetrieve({
        id: shiftId!,
        sort: 'desc',
      }),
    enabled: open && !!shiftId,
  });

  return (
    <Dialog open={open} onClose={onClose} size="2xl">
      <DialogTitle className="tw:flex tw:items-center tw:justify-between">
        <div>
          <div>Shift History</div>
          {shift && (
            <div className="tw:text-sm tw:font-normal tw:text-zinc-500">
              {formatDateTimeRange(shift)}
            </div>
          )}
        </div>
        <DialogCloseButton onClick={onClose} />
      </DialogTitle>
      <DialogBody>
        <ActivityLog
          enableCommentsFilter={false}
          enableStatusChangesFilter={true}
          enableUpdatesFilter={true}
          enableEventsFilter={false}
          notes={undefined}
          statusHistory={statusHistory as ActivityStatusHistory[] | undefined}
          changeHistory={changeHistory as ActivityHistory[] | undefined}
        />
      </DialogBody>
    </Dialog>
  );
};
